import { Logo, plate } from '@vgrubs/components';
import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 24px;
  margin-bottom: 40px;
  /* width: 100%; */

  @media (max-width: 800px) {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    padding: 10px 30px 40px 30px;
    margin: 0 -30px 0 -30px;

    > div {
      min-width: 70vw;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const Pill = styled.div<{ $amount: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 70px;
  background-color: ${({ $amount, theme }) =>
    $amount > 0 ? theme.green : theme.primary}26;

  border-radius: 20px;
`;

export const AreaTooltip = styled.div`
  width: max-content;
  height: max-content;
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  position: relative;
`;

export const GraphWrapper = styled.div`
  height: 300px;
  width: 100%;
  /* @media (max-width: 800px) {
    height: 55rem;
  }

  @media (max-width: 500px) {
    height: 30rem;
  } */
`;

export const BrandImage = styled.div`
  position: relative;

  > img {
    width: 55px;
    -webkit-filter: drop-shadow(0px 10px 10px #00000033);
    filter: drop-shadow(0px 10px 10px #00000033);
  }
  > div {
    position: absolute;
    height: 45px;
    width: 45px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    overflow: hidden;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      /* mix-blend-mode: multiply; */
    }
  }
`;

export const BrandImageComponent = ({ image }: { image?: string | null }) => {
  return (
    <BrandImage>
      <img src={plate} alt="plate" />
      <div>
        {image ? (
          <img src={image} alt="brand" />
        ) : (
          <Logo height="45" width="45" />
        )}
      </div>
    </BrandImage>
  );
};
